var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "paymentCaution" } }, [
    _c("div", { staticClass: "input_list" }, [
      _c("div", { staticClass: "dd_text" }, [
        _c("h2", [_vm._v("クレジットカードでお支払い：")]),
        _vm._v(" "),
        _c("ul", { staticClass: "text_li" }, [
          _c("li", [
            _vm._v(
              "以下のマークがついているクレジットカードでお支払い頂けます。"
            )
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("ご注文の確認が出来次第、製造を開始いたします。")]),
          _vm._v(" "),
          _c("li", [
            _c("img", { attrs: { src: _vm.getImage("bunner/card.webp") } })
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dd_text" }, [
      _c("h2", [_vm._v("金融機関でのお支払い：")]),
      _vm._v(" "),
      _c("ul", { staticClass: "text_li" }, [
        _c("li", [_vm._v("商品は入金確認後に製造開始いたします。")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "お振込み期限を過ぎますと希望納期に間に合わない場合はございます。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "次ページの決済ページにより振込期限をご確認の上、期間内にお支払いいただけますようお願い致します。"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63471f1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63471f1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/components/order/DcPaymentCaution.vue
// module id = null
// module chunks = 